var _circle, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContract(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.4,
    cy: 38.4,
    r: 38.4,
    fill: "#CEF6E7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_969_19223",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 45,
    height: 44
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.3999,
    y: 16,
    width: 44,
    height: 44,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_969_19223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.4001 56.3333C25.8723 56.3333 24.5737 55.7986 23.5043 54.7291C22.4348 53.6597 21.9001 52.3611 21.9001 50.8333V45.3333H27.4001V19.6666H54.9001V50.8333C54.9001 52.3611 54.3654 53.6597 53.2959 54.7291C52.2265 55.7986 50.9279 56.3333 49.4001 56.3333H27.4001ZM49.4001 52.6666C49.9196 52.6666 50.355 52.4909 50.7064 52.1396C51.0578 51.7882 51.2334 51.3528 51.2334 50.8333V23.3333H31.0668V45.3333H47.5668V50.8333C47.5668 51.3528 47.7425 51.7882 48.0939 52.1396C48.4453 52.4909 48.8807 52.6666 49.4001 52.6666ZM32.9001 32.5V28.8333H49.4001V32.5H32.9001ZM32.9001 38V34.3333H49.4001V38H32.9001ZM27.4001 52.6666H43.9001V49H25.5668V50.8333C25.5668 51.3528 25.7425 51.7882 26.0939 52.1396C26.4453 52.4909 26.8807 52.6666 27.4001 52.6666ZM27.4001 52.6666H25.5668H43.9001H27.4001Z",
    fill: "#000E4B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContract);
export default __webpack_public_path__ + "static/media/Contract.896f3f8d9545a9524b75af80a91e4847.svg";
export { ForwardRef as ReactComponent };